module.exports = __webpack_public_path__ + "media/styles/images/svg/white-close-ex-c1f4bf7aa37ae8690ee0382a3170d1b7.svg";